import React from 'react';

const Footer = () => {
  return (
    <React.Fragment>
      <footer id='footer'>
        <div className='inner'>
          <ul className='icons'>
            <li>
              <a href='https://www.instagram.com/esthra_shakara/' className='icon brands alt fa-instagram'>
                <span className='label'>Instagram</span>
              </a>
            </li>
            <li>
              <a href='https://twitter.com/awonmummy' className='icon brands alt fa-twitter'>
                <span className='label'>Twitter</span>
              </a>
            </li>
          </ul>
          <ul className='copyright'>
            <li>&copy; Esthra Shakara</li>
            <li>
              Designed by:{' '}
              <a href='https://africana.tectonics.online' target='_blank' rel='noopener noreferrer'>
                Quimby africana
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
